import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const { public: { sentry } } = useRuntimeConfig()

  if (!sentry?.dsn || !sentry?.release) {
    console.log('[sentry] not initialised (dsn/release not configured)')
    return
  }

  // build จากเครื่อง dev (ไม่ได้ตั้ง BUILD_TARGET) ไม่ส่งขึ้น Sentry
  // จะได้ไม่ไปปนกับ release ของ beta / prod ตั้ง SENTRY_DEV=true ถ้าอยากทดสอบ
  if (sentry.buildTarget === 'development' && !sentry.forceEnable) {
    console.log('[sentry] not initialised (development build)')
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    release: sentry.release,
    integrations: [],
    tracesSampleRate: 0,
  })

  console.log(`[sentry] initialised release=${sentry.release} env=${sentry.environment}`)
})
